/**
 * @generated SignedSource<<97b593c74569a78df8b9c50c0e1a798b>>
 * @lightSyntaxTransform
 * @nogrep
 */
/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
import { ConcreteRequest } from 'relay-runtime';

export type CreateCreditAccountError =
  | 'ACCOUNT_CREATION_BLOCKED'
  | 'ACCOUNT_CREATION_IN_PROGRESS'
  | 'CREDIT_ACCOUNT_ON_HOLD'
  | 'CREDIT_APPLICATION_INCOMPLETE'
  | 'CREDIT_APPLICATION_NOT_APPROVED'
  | 'CREDIT_APPLICATION_NOT_FOUND'
  | 'FAILURE_RETRIEVING_CREATED_ACCOUNT'
  | 'INVALID_BILLING_ADDRESS'
  | 'INVALID_CREDIT_LIMIT'
  | 'INVALID_SHIPPING_ADDRESS'
  | 'SHIPPING_RESIDENCY_NOT_FOUND'
  | 'UNKNOWN'
  | '%future added value';
export type CreateCreditAccountRequest = {
  creditApplicationId: string;
  deliveryMethod?: string | null;
  shippingAddress: AddressInput;
  signatureRequired?: boolean | null;
};
export type AddressInput = {
  countryCode?: string | null;
  locality?: string | null;
  primaryAddressLine?: string | null;
  secondaryAddressLine?: string | null;
  subdivision?: string | null;
  zip4?: string | null;
  zip5?: string | null;
};
export type ShippingAddressPageCreateCreditAccountMutation$variables = {
  q: CreateCreditAccountRequest;
};
export type ShippingAddressPageCreateCreditAccountMutation$data = {
  readonly createCreditAccount: {
    readonly data: {
      readonly customer: {
        readonly id: string;
      };
    } | null;
    readonly errors: ReadonlyArray<CreateCreditAccountError>;
  };
};
export type ShippingAddressPageCreateCreditAccountMutation = {
  response: ShippingAddressPageCreateCreditAccountMutation$data;
  variables: ShippingAddressPageCreateCreditAccountMutation$variables;
};

const node: ConcreteRequest = (function () {
  var v0 = [
      {
        defaultValue: null,
        kind: 'LocalArgument',
        name: 'q',
      },
    ],
    v1 = [
      {
        alias: null,
        args: [
          {
            kind: 'Variable',
            name: 'q',
            variableName: 'q',
          },
        ],
        concreteType: 'CreateCreditAccountValidation',
        kind: 'LinkedField',
        name: 'createCreditAccount',
        plural: false,
        selections: [
          {
            alias: null,
            args: null,
            concreteType: 'CreateCreditAccountResponse',
            kind: 'LinkedField',
            name: 'data',
            plural: false,
            selections: [
              {
                alias: null,
                args: null,
                concreteType: 'CreditCustomer',
                kind: 'LinkedField',
                name: 'customer',
                plural: false,
                selections: [
                  {
                    alias: null,
                    args: null,
                    kind: 'ScalarField',
                    name: 'id',
                    storageKey: null,
                  },
                ],
                storageKey: null,
              },
            ],
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'errors',
            storageKey: null,
          },
        ],
        storageKey: null,
      },
    ];
  return {
    fragment: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Fragment',
      metadata: null,
      name: 'ShippingAddressPageCreateCreditAccountMutation',
      selections: v1 /*: any*/,
      type: 'Mutation',
      abstractKey: null,
    },
    kind: 'Request',
    operation: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Operation',
      name: 'ShippingAddressPageCreateCreditAccountMutation',
      selections: v1 /*: any*/,
    },
    params: {
      cacheID: '0d374438683713033bf4067bbc2a06a3',
      id: null,
      metadata: {},
      name: 'ShippingAddressPageCreateCreditAccountMutation',
      operationKind: 'mutation',
      text: 'mutation ShippingAddressPageCreateCreditAccountMutation(\n  $q: CreateCreditAccountRequest!\n) {\n  createCreditAccount(q: $q) {\n    data {\n      customer {\n        id\n      }\n    }\n    errors\n  }\n}\n',
    },
  };
})();

(node as any).hash = 'b09ca75ec88f69d98b1f239b67b2c772';

export default node;
